module.exports = __webpack_public_path__ + "img/cdc875b.jpg";